const BLOG_API_BASE = "https://api.pwned.place:4000/blog/";

const getMeta = async () => {
  const url = `${BLOG_API_BASE}meta/`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
};

const getPost = async (slug) => {
  const url = `${BLOG_API_BASE}get/${slug}/`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
};

const getMetaPost = async (slug) => {
  const url = `${BLOG_API_BASE}meta/${slug}/`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
};

const searchPosts = async (query) => {
  const encodedQuery = encodeURIComponent(query);
  const url = `${BLOG_API_BASE}search/${encodedQuery}`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
};

const getBannerSrc = (slug) => {
  return `${BLOG_API_BASE}banners/${slug}`;
};

export { getMeta, getPost, getMetaPost, searchPosts, getBannerSrc };
